import { selectAvatarUrl, selectCorepassId } from "@src/selectors";
export class AuthService {
    static getCorepassId() {
        return selectCorepassId().get();
    }
    static getAvatarUrl() {
        return selectAvatarUrl().get();
    }
}
